const btnForgotPassword = {
  text: 'Reset Password'
};

export default btnForgotPassword;
